import React from 'react';
import {connect} from 'react-redux';
import { Link } from 'react-router-dom';

const DefaultPage = (props) => {
    return <div>
        <div className="row">
            <div className="col">
                <h1>Välkommen!</h1>
                <br />
            </div>
        </div>
        <div className="row">
            <div className="col-8">

                {props.contracts && props.contracts.length > 0 &&
                    <div className="alert alert-light" role="alert">
                        {props.contracts.length}st nya kontrakt har skrivits på! <Link
                    to="/contracts">Se alla kontrakt</Link>
                    </div>
                }

            </div>
        </div>
    </div>;
}

export default connect(state => state.sinceState)(DefaultPage);
